import { GET_COUNTRIES } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CountryService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
    }

    getCountries(countriesParams: any): Observable<any> {
        const url = GET_COUNTRIES + this.makeQueryString(countriesParams);
        return this.getRequest(url, null);
    }
}
